import { axios } from '@/utils/request'

const api = {
  teamList: '/badminapi/team/teamlist',
  memberList: '/badminapi/team/sellerList',
  changeLeader: '/badminapi/team/changeTeam',
  sellerGroupList: '/badminapi/seller/groupList',
}

export default api

export function getTeamList(parameter) {
  return axios({
    url: api.teamList,
    method: 'get',
    params: parameter
  })
}

export function changeLeader(parameter) {
  return axios({
    url: api.changeLeader,
    method: 'post',
    data: parameter
  })
}

export function getSellerGroupList(parameter) {
  return axios({
    url: api.sellerGroupList,
    method: 'get',
    params: parameter
  })
}
export function getTeamMemberList(parameter) {
  return axios({
    url: api.memberList,
    method: 'get',
    params: parameter
  })
}